<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up applicant_chk com_pop" style="max-width: 1200px">
        <div class="pop_tit _flex">
            <p>{{ state.item.title }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>
        <div class="sch_condition_wrap">
            <div class="left _column _flex">
                <div class="date_wrap">
                    <template v-if="state.item.state == 2">
                        <span class="state_tag">진행중</span>
                    </template>
                    <template v-else-if="state.item.state == 1">
                        <span class="state_tag waiting">대기중</span>
                    </template>
                    <template v-else>
                        <span class="state_tag finish">마감</span>
                    </template>
                    <div class="collection_period">
                        <span>
                            <img src="img/time_icon.png" alt="" />
                            모집기간
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.item.recruitStartDate), ".") }}</span>
                        <em>-</em>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.item.recruitEndDate), ".") }}</span>
                    </div>
                    <div class="end_point">
                        <span>
                            <img src="img/time_icon.png" alt="" />
                            신청종료일
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.item.applyDate), ".") }}</span>
                    </div>
                    <div class="activity_duration" v-if="state.item.activeStartDate && state.item.activeEndDate">
                        <span>
                            <img src="img/cal_icon.png" alt="" />
                            활동기간
                        </span>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.item.activeStartDate), ".") }}</span>
                        <em>-</em>
                        <span>{{ CommonUtils.dateFormatYY(new Date(state.item.activeEndDate), ".") }}</span>
                    </div>
                </div>
            </div>
            <div class="right _align_bottom _flex">
                <button type="button" class="blue_btn" style="padding: 0 10px" @click="showCase()">질문추가+</button>
            </div>
        </div>

        <div class="list_container _flex">
            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <col style="width: 80px" />
                        <col style="width: 100px" />
                        <col />
                        <col style="width: 140px" />
                    </colgroup>

                    <tbody>
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="idx">
                                <td class="cnt">
                                    <button type="button" class="move_up _sub" @click="changeOrder(item.idx, 0)">
                                        <img src="img/up_icon.png" alt="" />
                                    </button>
                                    <button type="button" class="move_down _sub" @click="changeOrder(item.idx, 1)">
                                        <img src="img/down_icon.png" alt="" />
                                    </button>
                                </td>

                                <td v-text="strGubun(item.type)"></td>
                                <td v-text="item.title" style="text-align: left"></td>
                                <td class="cnt p_5">
                                    <button type="button" class="table_btn _blue" @click="showCase(item)">수정</button>
                                    <button type="button" class="table_btn _gray" @click="isDelete(item.idx)">삭제</button>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="6"><div class="tb_subject" style="text-align: center; width: 100%">등록한 신청 양식이 없습니다.</div></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
        @callback="callBackModal"
    ></ModalDefault>

    <CaseListModal
        v-if="state.isShowCaseModal"
        :item="state.itemForItem"
        @close="state.isShowCaseModal = false"
        @callback="
            state.isShowCaseModal = false;
            getList();
        "
    ></CaseListModal>
</template>
<script lang="ts">
    import {
        onMounted,
        reactive,
        watch,
        onUnmounted,
        CommonUtils,
        apiService,
        types,
        getMessageByCode,
        ModalDefault,
        CaseListModal,
    } from "@/BaseComponent";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
            type: {
                type: String,
                default: "board",
                validator: (value: string) => ["board", "event"].includes(value),
            },
        },
        emits: ["close", "callback"],
        components: { ModalDefault, CaseListModal },
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                item: {} as any,
                list: [] as any,

                idxForRemove: 0 as number,

                itemForItem: {} as any,
                isShowCaseModal: false as boolean,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            onMounted(() => {
                state.idx = props.idx;
                boardDetail();
                getList();
            });

            watch(props, () => {
                state.idx = props.idx;
                boardDetail();
                getList();
            });

            onUnmounted(() => {});

            const closeModal = () => emit("close");

            const boardDetail = async () => {
                const type = props.type === "board" ? 1 : 2;
                const res = await apiService.board.detail(type, props.idx);
                if (res.returnCode === 0) {
                    state.item = res.data;
                }
            };

            const strGubun = (val: number) => {
                switch (val) {
                    case 1:
                        return "객관식";
                    case 2:
                        return "객관식(복수)";
                    case 3:
                        return "주관식";
                    default:
                        return "";
                }
            };

            const getList = async () => {
                state.list = [];

                const res = await apiService.board.listForForm(state.idx);
                if (res.returnCode === 0) {
                    state.list = res.data;
                } else {
                    console.error(res.description);
                    state.list = [];
                }
            };

            const changeOrder = async (idx: number, arrow: number) => {
                const res = await apiService.board.isOrderForm(idx, arrow);
                if (res.returnCode === 0) {
                    getList();
                }
            };

            const isDelete = (idx: number) => {
                state.modalTab = 5;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;

                state.idxForRemove = idx;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    remove(state.idxForRemove);
                }
            };

            const remove = async (idx: number) => {
                const res: types.BaseResponse = await apiService.board.removeForm(idx);

                if (res.returnCode === 0) {
                    state.isShowModal = false;
                    getList();
                }
            };

            const showCase = (item?: number) => {
                if (item) state.itemForItem = item;
                else state.itemForItem = { boIdx: state.item.idx };
                state.isShowCaseModal = true;
            };

            return {
                state,
                props,
                CommonUtils,
                isDelete,
                closeModal,
                strGubun,
                changeOrder,
                showCase,
                callBackModal,
                getList,
            };
        },
    };
</script>

<style scoped>
    .applicant_chk .date_wrap {
        margin: 0;
    }
    .common_table td {
        border: 0;
        padding: 10px;
    }

    .common_table td button {
        margin-right: 10px;
    }
</style>
